import React, { useState } from 'react';
import styled from 'styled-components';
import { TextFieldCSS } from '../../reusable/Input';
import { formatHMS, parseDurationInput } from './util';

const StyledInput = styled.input`
  ${TextFieldCSS}
  padding: 8px;
`;

export interface DurationInputProps {
  id: string;
  totalSeconds: number;
  onChange: (totalSeconds: number) => void;
  onBlur?: () => void;
}

const DurationInput: React.FC<DurationInputProps> = ({
  id,
  totalSeconds,
  onChange,
  onBlur,
}) => {
  const [editing, setEditing] = useState(false);
  const [raw, setRaw] = useState('');

  const commit = (value: string) => {
    onChange(parseDurationInput(value));
    onBlur?.();
    setEditing(false);
  };

  return (
    <StyledInput
      id={id}
      data-testid={id}
      type="text"
      value={editing ? raw : formatHMS(totalSeconds)}
      placeholder={
        editing ? formatHMS(totalSeconds) || 'e.g. 1h30m' : undefined
      }
      onChange={(e) => {
        setEditing(true);
        setRaw(e.target.value);
      }}
      onFocus={() => {
        setEditing(true);
        setRaw('');
      }}
      onBlur={(e) => {
        if (e.target.value !== '') {
          commit(e.target.value);
        } else {
          setEditing(false);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          const value = (e.target as HTMLInputElement).value;
          if (value !== '') {
            commit(value);
          }
        }
      }}
      aria-label="duration"
    />
  );
};

export default DurationInput;
